import { Alert, AlertIcon, AlertTitle, Flex } from "@chakra-ui/react";
import { getRouteApi, Navigate } from "@tanstack/react-router";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useAuthentication } from "./AuthenticationContext";

function FullPageCenteredContainer({ children }: { children: ReactNode }) {
  return (
    <Flex
      height="100vh"
      width="100vw"
      overflow="hidden"
      justifyContent={"center"}
      alignItems={"center"}
      flexDirection={"column"}
    >
      {children}
    </Flex>
  );
}

const routeApi = getRouteApi("/_unauthenticated/oauth2/callback");

export default function OAuth2AuthCodeCallback() {
  const { isPendingAuthentication, error } = useAuthentication();
  const { t } = useTranslation();
  const { state } = routeApi.useSearch();

  // Wait for both authentication to finish and user to be present
  if (isPendingAuthentication) {
    return (
      <FullPageCenteredContainer>
        <Alert status="loading" maxW={"container.sm"}>
          <AlertIcon />
          <AlertTitle>{t("authorization_in_progress")}</AlertTitle>
        </Alert>
      </FullPageCenteredContainer>
    );
  }

  if (error) {
    return (
      <FullPageCenteredContainer>
        <Alert status="error" maxW={"container.sm"}>
          <AlertIcon />
          {error}
        </Alert>
      </FullPageCenteredContainer>
    );
  }

  const redirectTo = state ?? "/";

  return (
    <>
      <FullPageCenteredContainer>
        <Alert status="info" maxW={"container.sm"}>
          <AlertIcon />
          {t("will_redirect_to")} {state} ...
        </Alert>
      </FullPageCenteredContainer>
      <Navigate to={redirectTo} />
    </>
  );
}
